<template>
  <div
    class="w-full relative flex flex-col rounded-xl space-y-8 h-100 overflow-hidden font-lato items-center justify-center"
    style="box-shadow: 0px 4px 20px 0px #48507029"
  >
    <p class="text-[#FE7F2D] text-xl lg:text-6xl font-lato">
      Ничего не найдено
    </p>
    <p class="mt-8 text-base lg:text-lg font-lato">
      По вашему запросу товары не найдены<br />
      Попробуйте выбрать другие фильтры
    </p>

    <slot />
  </div>
</template>
